import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withProps from 'recompose/withProps';
import setDisplayName from 'recompose/setDisplayName';
import {Header, Segment, Container} from 'semantic-ui-react';
import {sortOptionsFactory, filterOptionsFactory} from 'viewOptions/factories';
import {pageCount, prependRecentIfFirstPage, toggleSort} from 'utils/DBUtils';
import {createResourcePageSelector, createResourcePageItemsSelector} from 'resources/selectors';
import {getResourcePageAction, updatePageNumberForResourceAction} from 'resources/actions';
import * as ResourceApi from 'api/resources';
import PagingBar from 'components/common/PagingBar';
import UGCCampaignItem from './UGCCampaignItem';
import Spinner from './Spinner';

const getResourcePage = createResourcePageSelector(ResourceApi.Types.Campaign);
const getPageItems = createResourcePageItemsSelector(ResourceApi.Types.Campaign);

const mapStateToProps = state => {
  const {fetching} = state.ugc;
  const {page, count, total} = getResourcePage(state.resources);
  const campaigns = prependRecentIfFirstPage(page, count, [], getPageItems(state.resources));

  return {
    fetching,
    campaigns,
    currentPage: page,
    count,
    total
  };
};

const pageSize = 20;
const sortOptions = sortOptionsFactory('_created');
sortOptions.sorts = toggleSort(sortOptions.sorts, '_created');

const filterOptions = filterOptionsFactory();

const mapDispatchToProps = dispatch => bindActionCreators({
  getPage: page => getResourcePageAction(ResourceApi.Types.Campaign, pageSize, page, sortOptions, filterOptions),
  onPageSelected: page => updatePageNumberForResourceAction(ResourceApi.Types.Campaign, page),
  onNextClicked: currentPage => updatePageNumberForResourceAction(ResourceApi.Types.Campaign, currentPage + 1),
  onPreviousClicked: currentPage => updatePageNumberForResourceAction(ResourceApi.Types.Campaign, currentPage - 1)
}, dispatch);

const UGCModerationPage = compose(
  setDisplayName('UGCModerationPage'),
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount() {
      this.props.getPage(1);
    }
  }),
  withProps(props => ({
    pagingProps: {
      count: pageCount(props.total, pageSize),
      total: props.total,
      currentPage: props.currentPage,
      maxPages: 10,
      onPageSelected: props.onPageSelected,
      onNextClicked: props.onNextClicked,
      onPreviousClicked: props.onPreviousClicked
    }
  }))
)(props => (
  <div className='ugc-campaign-list'>
    <Header as='h1'>UGC Campaigns</Header>
    {props.fetching ? <Spinner /> : (
      <Fragment>
        {props.campaigns.length ? (
          <Segment.Group raised className='fadeInUp animResponse'>
            {props.campaigns.map(campaign => <UGCCampaignItem key={campaign.id} {...campaign} />)}
          </Segment.Group>
        ) : (
          <Container>
            <Header as='h3' block>
              No campaigns found
            </Header>
          </Container>
        )}
        <PagingBar {...props.pagingProps} />
      </Fragment>
    )}
  </div>
));

export default UGCModerationPage;



// WEBPACK FOOTER //
// ./public/pages/UGCModeration/UGCModerationPage.jsx